<template>
  <div class="footer-card animate__animated wow animate__fadeIn">
    <h3>项目咨询</h3>
    <div class="span"> </div>
    <p>
      <span><i class="el-icon-user-solid"></i> 联系人：{{name}}</span>
      <a>|</a>
      <span><i class="el-icon-phone"></i>联系电话：{{phone}}</span>
    </p>
    <slot></slot>
  </div>
</template>

<script>
import WOW from "../../node_modules/wowjs/dist/wow";

export default {
  props: {
    name: {
      require: true,
      default: '孙先生'
    },
    phone: {
      require: true,
      default: '135-2108-4802'
    }
  },
  data() {
    return {

    }
  },
  created() {
  },
  mounted() {
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.footer-card {
  height: 3.7895rem;
  width: 100%;
  background: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/23FAADC5F9424EDBA1CFF4FC287CF11A-6-2.png') no-repeat;
  background-size: 100% 100%;
  padding-left: 3rem;
  box-sizing: border-box;
  padding-top: 0.8632rem;
  @media screen and (max-width: 540px) {
    height: 180px;
    background: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/8EC50F5047BA4E86A0DF70FB834F9199-6-2.png') no-repeat;
    background-size: 100% 100%;
    padding-left: 40px;
    padding-top: 33px;
  }
  h3 {
    color: #ffffff;
    font-size: 0.3579rem;
    margin: 0;
    padding-bottom: 0.1053rem;
    @media screen and (max-width: 540px) {
      font-size: 19px;
    }
  }
  .span {
    display: block;
    height: 0.0632rem;
    width: 0.3158rem;
    background-color: #fff;
    margin-bottom: 0.9474rem;
    @media screen and (max-width: 540px) {
      width: 17px;
      height: 4px;
      margin-bottom: 1.8947rem;
    }
  }
  p {
    font-size: 0.2842rem;
    color: #ffffff;
    @media screen and (max-width: 540px) {
      font-size: 15px;
    }
    a {
      padding: 0 0.2105rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
    }
    span {
      @media screen and (max-width: 540px) {
        display: block;
        padding-bottom: 10px;
      }
    }
  }
}
</style>
